import { useContext, useState } from 'react';
import { DrumConfigurationContext } from '../../context/DrumConfigurationContext';
import { FormContext } from '../../context/FormContext';
import { useTranslation } from "react-i18next";
import { scrollToTop } from "../../utility/smoothScroll";
import { countryCodeName } from "../../countries"
import { AppContext } from "../../context/AppContext";
import "./Buttons.css";

import axios from "axios";

const GeneratePDFButton = ({handleButtonClick, validateForm}) => {

    const { drumConfigurations, calculateMaximumLoad } = useContext(DrumConfigurationContext);
    const { formData } = useContext(FormContext);
    const { t, i18n } = useTranslation();
    const { handlePageChange, setConfirmationResult } = useContext(AppContext);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const apiUrl = process.env.REACT_APP_API_URL;

    const getTranslations = () => {
        const currentLanguage = i18n.language;
        const countries = countryCodeName.reduce((acc, country) => {
            acc[country.code] = country.name[currentLanguage];
            return acc;
        }, {});

        return {
            contact: {
                header: t("navbar.contactPage"),
                label: {
                    name: t("page.contact.label.name"),
                    company: t("page.contact.label.company"),
                    address: t("page.contact.label.address"),
                    nip: t("page.contact.label.nip"),
                    phone: t("page.contact.label.phone"),
                    email: t("page.contact.label.email")
                }
            },
            billing: {
                header: t("pdf.contact.header.billing"),
                label: {
                    billingCompany: t("page.contact.label.billingCompany"),
                    billingAddress: t("page.contact.label.billingAddress"),
                    billingNip: t("page.contact.label.billingNip"),
                }
            },
            IDSBilling: {
                header: t("pdf.contact.header.billingIDS"),
                label: {
                    IDSBillingCompany: t("page.contact.label.name"),
                    IDSBillingAddress: t("page.contact.label.address"),
                    IDSBillingNip: t("page.contact.label.nip"),
                }
            },
            installation: {
                headers: {
                    installation: t("page.installation.header.installation"),
                    services: t('pdf.installation.header.services'),
                    transfer: t('pdf.installation.header.transfer'),
                    it: t("page.installation.header.it"),
                    subscription: t("pdf.installation.header.subscription")
                },
                label: {
                    company: t("page.installation.label.company"),
                    address: t("page.installation.label.address"),
                    phone: t("page.installation.label.phone"),
                    name: t("page.installation.label.name"),
                    country: t("page.installation.label.country"),
                    industry: t("page.installation.label.industry"),
                    installation: t("page.installation.label.installation"),
                    configuration: t("page.installation.label.configuration"),
                    database: t("page.installation.label.database"),
                    productSchemes: t("page.installation.label.productSchemes"),
                    machinesTraining: t("page.installation.label.machinesTraining"),
                    webTraining: t("page.installation.label.webTraining"),
                    serviceTraining: t("page.installation.label.serviceTraining"),
                    internetConnection: t("pdf.installation.label.internetConnection"),
                    networkType: t("page.installation.label.networkType"),
                    preferredLogin: t("page.installation.label.preferredLogin"),
                    cardReaderType: t("page.installation.label.cardType"),
                    contactPerson: t("page.installation.label.contactPerson"),
                    emailAddress: t("page.installation.label.email"),
                    contactPersonPhone: t("page.installation.label.contactPersonPhone"),
                    machineTransfer: t("page.installation.label.machineTransfer"),
                    machineInstallation: t("page.installation.label.machineInstallation"),
                    forkliftAvailable: t("page.installation.label.forkliftAvailableShort"),
                    isDeliveryNotificationRequired: t("page.installation.label.deliveryNotificationShort"),
                    transport: t("page.installation.label.transport"),
                    rentalPeriod: t("page.installation.label.rentalPeriod"),
                    paymentMethod: t("page.installation.label.paymentMethod"),
                    subscriptionCost: t("page.installation.label.subscriptionCost"),
                    expectedDeliveryDate: t("page.installation.label.expectedDeliveryDate"),
                    comment: t("page.installation.label.comment"),
                    subscriptionPeriod: t("page.installation.label.subscriptionPeriod")
                },
                data: {
                    new: t("page.installation.radio.new"),
                    reinstall: t("page.installation.radio.reinstall"),
                    sale: t("page.installation.radio.sale"),
                    rental: t("page.installation.radio.rental"),
                    transfer: t("page.installation.radio.transfer"),
                    leasing: t("page.installation.radio.leasing"),
                    asd: t("page.installation.radio.asd"),
                    lan: t("page.installation.radio.lan"),
                    gsm: t("page.installation.radio.gsm"),
                    card: t("page.installation.radio.card"),
                    login: t("page.installation.radio.login"),
                    other: t("page.installation.radio.other"),
                    unique: t("page.installation.radio.unique"),
                    mifare: t("page.installation.radio.mifare"),
                    static: t("page.installation.radio.static"),
                    ownInstallation: t("page.installation.radio.ownInstallation"),
                    ownTransport: t("page.installation.radio.ownTransport"),
                    true: t("global.label.yes"),
                    false: t("global.label.no"),
                    nodatafound: t("global.label.nodatafound"),
                    monthly: t("page.installation.radio.monthly"),
                    semiannual: t("page.installation.radio.semiannual"),
                    annual: t("page.installation.radio.annual"),
                    ...countries,
                },
            },
            machines: {
                header: t("navbar.machinesPage"),
                label: {
                    machineType: t("page.machines.header.machineType"),
                    version: t("page.machines.label.version"),
                    barcodeReader: t("page.machines.label.barcodeReader"),
                    barcodeReaderOption: t("page.machines.label.barcodeReaderOption"),
                    barcodeReaderType: t("page.machines.label.barcodeReaderType"),
                    drumScanner: t("page.machines.label.drumScanner"),
                    type: t("page.machines.label.type"),
                    logoOnDisplay: t("page.machines.label.logoOnDisplay"),
                    color: t("page.machines.label.color"),
                    rightDoorDetail: t("page.machines.checkbox.rightDoorColor"),
                    leftDoorDetail: t("page.machines.checkbox.leftDoorColor"),
                    rightCaseDetail: t("page.machines.checkbox.rightCaseDesign"),
                    leftCaseDetail: t("page.machines.checkbox.leftCaseDesign"),
                    backCaseDetail: t("page.machines.checkbox.backCaseDesign"),
                    topCaseDetail: t("page.machines.checkbox.topCaseDesign"),
                    panelSide: t("page.machines.label.panelSide"),
                    plexiglassWindows: t("page.machines.checkbox.plexiglassWindows"),
                    additionalOptions: t("page.machines.label.additionalOptions"),
                },
                data: {
                    standard: t("page.machines.radio.standard"),
                    custom: t("page.machines.radio.custom"),
                    dynamic: t("page.machines.radio.dynamic"),
                    uncertain: t("page.machines.radio.uncertain"),
                    standardcolor: t("page.machines.radio.standardColor"),
                    nonstandardcolor: t("page.machines.radio.nonstandardColor"),
                    standardReader: t("page.machines.radio.standardReader"),
                    customReader: t("page.machines.radio.customReader"),
                    yes: t("global.label.yes"),
                    no: t("global.label.no"),
                    nodatafound: t("global.label.nodatafound"),
                    left: t("page.machines.radio.leftSide"),
                    right: t("page.machines.radio.rightSide")
                },
            },
            summary: {
                header: t("page.summary.header.summary"),
                label: {
                    comment: t("page.summary.label.comment")
                }
            },
            pdf: {
                header: { orderForm: t("header.title") },
                terms: {
                    header: t("pdf.terms.header"),
                    orderTerms: t("pdf.terms.orderTerms"),
                    implementationTerms: t("pdf.terms.implementationTerms"),
                    deliveryTerms: t("pdf.terms.deliveryTerms"),
                    declaration: t("pdf.terms.declaration"),
                    gdprPrefix: t("pdf.terms.gdprPrefix"),
                    gdprHighlight: t("pdf.terms.gdprHighlight"),
                    gdprSuffix: t("pdf.terms.gdprSuffix")
                },
                drum: {
                    cellCount: t("pdf.drum.cellCount"),
                    maxLoad: t("pdf.drum.maxLoad")
                }
            }
        };
    };

    const getLoadsForMachines = () => {
        const machinesForms = formData?.machinesForms || [];

        return machinesForms.map((machineForm, machineIndex) => {
            const machineType = machineForm?.machineType || '';
            try {
                const load = calculateMaximumLoad(machineIndex, machineType);
                return {
                    machineIndex,
                    machineType,
                    load
                };
            } catch (e) {
                return null;
            }
        });
    }

    const submitOrder = async () => {
        try {
            const payload = new FormData();
            payload.append("selectedLanguage", i18n.language);
            payload.append("formData", JSON.stringify(formData));
            payload.append("drumConfigurations", JSON.stringify(drumConfigurations));
            payload.append("translations", JSON.stringify(getTranslations()));
            payload.append("machineLoads", JSON.stringify(getLoadsForMachines()));

            const response = await axios.post(apiUrl, payload, {
                responseType: "blob",
                timeout: 120000,
            });
            const contentDisposition = response.headers?.["content-disposition"];
            const orderNumber = getParamFromContentDisposition(contentDisposition, "ordernumber");

            if (response.status !== 200 || !orderNumber || !response.data) {
                throw new Error("Order submission response is incomplete");
            }

            if (response.headers?.["x-email-delivery"] === "failed") {
                // The order is persisted but at least one e-mail was not sent;
                // keep the PDF available so the client can deliver it manually.
                setConfirmationResult({
                    success: false,
                    emailFailed: true,
                    pdfDownloadData: response.data,
                    orderNumber,
                });
                return;
            }

            setConfirmationResult({
                success: true,
                pdfDownloadData: response.data,
                orderNumber,
            });
        } catch (error) {
            console.error("Error submitting order");
            setConfirmationResult({
                success: false,
            });
        }
    }

    function getParamFromContentDisposition(cd, param) {
        if (!cd) return null;

        const match = cd.match(new RegExp(`${param}\\*?=(?:UTF-8''|")?([^;"\\n]+)"?`, "i"));
        if (!match?.[1]) return null;

        return decodeURIComponent(match[1]);
    }

    function changePage() {
        if (typeof handleButtonClick === 'function') {
            handleButtonClick();
        }

        handlePageChange(4);
    }

    const handleAction = async () => {
        if (isSubmitting) {
            return;
        }

        if (!validateForm()) {
            scrollToTop();
            return;
        }

        setIsSubmitting(true);
        try {
            await submitOrder();
        } finally {
            setIsSubmitting(false);
        }

        changePage();
    };

    return (
        <button className="btn-next" style={{ width: '50%' }} onClick={handleAction} disabled={isSubmitting}>
            {isSubmitting && <span className="btn-spinner" aria-hidden="true" />}
            {t("global.btn.postOrder")}
        </button>
    )
};

export default GeneratePDFButton;
